import Skeleton from '@/components/atoms/Skeleton/Skeleton';

const MatchCardSkeleton = () => (
  <div className="flex w-full items-center justify-between px-4 py-2 gap-4 dark:bg-black-400 bg-white_theme-50 rounded-lg">
    {/* Date skeleton */}
    <Skeleton className="w-8 h-3" />

    <div className="w-full flex items-center justify-between">
      {/* Teams section */}
      <div className="space-y-1">
        {/* First team */}
        <div className="flex items-center gap-2">
          <Skeleton className="h-4 w-4 rounded-full" />
          <Skeleton className="w-16 h-3" />
        </div>
        {/* Second team */}
        <div className="flex items-center gap-2">
          <Skeleton className="h-4 w-4 rounded-full" />
          <Skeleton className="w-16 h-3" />
        </div>
      </div>

      {/* Score section */}
      <div className="flex flex-col items-center space-y-1">
        <Skeleton className="w-3 h-3" />
        <Skeleton className="w-3 h-3" />
      </div>
    </div>

    {/* Win/Loss indicator */}
    <Skeleton className="w-5 h-5 rounded-sm" />
  </div>
);

const LastMatchesSkeleton = ({ showTitle = true }: { showTitle?: boolean }) => (
  <div>
    {showTitle && (
      <div className="mb-2">
        <Skeleton className="w-32 h-3" />
      </div>
    )}

    {/* Match cards */}
    <div className="space-y-2">
      <MatchCardSkeleton />
      <MatchCardSkeleton />
      <MatchCardSkeleton />
    </div>

    {/* Show more link */}
    <div className="w-fit mx-auto flex items-center justify-center gap-1.5 mt-2">
      <Skeleton className="w-24 h-3" />
      <Skeleton className="w-3.5 h-3.5" />
    </div>
  </div>
);

const LivescoreH2HDetailsSkeleton = () => {
  return (
    <div className="space-y-4">
      {/* Home team last matches */}
      <LastMatchesSkeleton />

      {/* Away team last matches */}
      <LastMatchesSkeleton />

      {/* Head-to-head matches */}
      <LastMatchesSkeleton showTitle={true} />
    </div>
  );
};

export default LivescoreH2HDetailsSkeleton;
